import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ContinueButton from '@/components/ContinueButton.vue';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import QueryKey from '@/enums/QueryKey';
    import { useQueryClient } from '@tanstack/vue-query';
    import type { VatSubmission, SharedData } from '@/types';
    import { useVatStore } from '@/stores/vat';
    import { computed, ref } from 'vue';
    import { usePage } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SubmitVat',
  props: {
    vatSubmission: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();
    const queryClient = useQueryClient();
    const vatStore = useVatStore();
    const page = usePage<SharedData>();

    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const submitted = ref(false);

    const { mutate, isPending } = useMutation({
        mutationFn: (vatSubmissionId: number) =>
            axios.post(route('v2.vat.submission.submit', vatSubmissionId)),
        onSuccess: (data) => {
            submitted.value = true;
            toast.success(t('vat.submission_successful'));
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKey.VAT,
                    selectedCompanyId,
                    vatStore.date,
                    vatStore.selectedGrouping,
                ],
            });
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.message || t('vat.submission_failed'));
        },
    });

    function submitVat() {
        if (isPending.value) return;
        mutate(props.vatSubmission.id);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContinueButton, {
    disabled: !_ctx.vatSubmission.purchase_vat || !_ctx.vatSubmission.sales_vat,
    loading: _unref(isPending) || submitted.value,
    onClick: submitVat
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('vat.submit')), 1)
    ]),
    _: 1
  }, 8, ["disabled", "loading"]))
}
}

})